import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setVisitors, setActivityDate, setErrorMessageStep, setFlowType, setHeldUnderAge, setSelectedActivity, setSteps } from "../../store/MahutiReducer";
import { ELEMENT_LINK, FLOW_TYPE, NO_AVAILABLE_TICKETS_TODAY, PAGES, PREFIX_PATH, scrollToSection, STEPS, VISITORS_LIMIT_ERROR_MSG } from "../../utils/GlobalParams";
import { getDatesSF } from "../../utils/sfUtils";
import { isGenericEventProduct, isGenericOnlyLp, visitorsPatchForProduct } from "../../utils/audienceUtils";
import { mySteps, myStepsActivity, myStepsActivityMOBILE, myStepsMOBILE, onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import MahutiCalender from "../mahuti-calender/MahutiCalender";
import MahutiInputVisitors from "../mahuti-input-visitors/MahutiInputVisitors";

import './LandingPageStepOne.css'
import { isMobile } from "react-device-detect";

export default function LandingPageStepOne() {

    const store = useSelector(state => state.reducer)
    const dispatch = useDispatch();
    const [errorMessageHead, setErrorMessageHead] = useState(undefined)
    const [activityDates, setActivityDates] = useState([]);
    const [isLoadingDates, setIsLoadingDates] = useState(undefined);
    const [ticketsAvailable, setTicketsAvailable] = useState(undefined);
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    let lpPrefix = store.lpName ? '/' + store.lpName : '';

    const refMount = useRef(true);
    useEffect(() => {
        if (refMount.current) {
            refMount.current = false;
            setIsLoadingDates(true);
        }
        return () => {
            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => dispatch(setActivityDate(undefined)));
        }
    }, [])

    useEffect(() => {
        store.products?.length > 0 && init()
    }, [store.products])

    // A generic-only LP is adult-only from the first step: park the child
    // count on entry (restored if the shopper moves to a family LP product).
    useEffect(() => {
        if (isGenericOnlyLp(store.products) && (store.visitors?.underAge || 0) > 0 && !store.isInternalMode) {
            dispatch(setHeldUnderAge(store.visitors?.underAge));
            dispatch(setVisitors({ underAge: 0 }));
        }
    }, [store.products])

    useEffect(() => {
        store.selectedActivity && callGetDates()
    }, [store.selectedActivity])

    // Generic events sell adult tickets only - normalize the stored visitors
    // whenever the selected product's audience requires it. The child count
    // is HELD while a generic event is selected and restored on the next
    // family selection, so the up-front visitors choice carries across
    // products in one shopping session.
    useEffect(() => {
        const patch = visitorsPatchForProduct(store.selectedActivity, store.visitors, store.isInternalMode, store.heldUnderAge, isGenericOnlyLp(store.products));
        if (patch) {
            dispatch(setHeldUnderAge(patch.underAge === 0 ? store.visitors?.underAge : undefined));
            dispatch(setVisitors(patch));
        }
    }, [store.selectedActivity])

    const init = () => {
        if((location.pathname.includes(`/${PAGES.ACTIVITY_FLOW}`))){
            if(params.id){
                if(store.products.length > 0){
                    let index = store.products.findIndex(product => product.URI_Indentifier__c === params.id)
                    if(index !== -1){
                        dispatch(setSelectedActivity(store.products[index]));
                    }else{
                        console.log('no activity match')
                        sendMeHome()
                    }
                }else{
                    console.log('no products')
                    sendMeHome()
                }
            }else{
                console.log('no params.id')
                sendMeHome()
            }
        }else if(!location.pathname.includes(`/${PAGES.ACTIVITY_FLOW}`)) {
            if(location.pathname.includes(`${PREFIX_PATH}${lpPrefix}/${PAGES.DATE_FLOW}`)) {
                callGetDates()
            }else{
                console.log('!location.pathname.includes(`${PREFIX_PATH}${lpPrefix}/${PAGES.DATE_FLOW}`)')
                sendMeHome()
            }
        }else{
            console.log('location.pathname.includes(`/${PAGES.ACTIVITY_FLOW}`)')
            sendMeHome()
        }
    }

    const sendMeHome = () => {
        navigate(`${PREFIX_PATH}${lpPrefix}`)
    }

    const callGetDates = () => {
        // if Edit Mode
        scrollToSection(location.hash ? ELEMENT_LINK[location.hash] : ELEMENT_LINK["#productDetailsDisplay"]);
        const visitors = (store.visitors?.adults || 0) + (store.visitors?.underAge || 0);
        getDatesSF(store.activityEditMode ? 2 : visitors, store.selectedActivity?.productId, store.lpName || undefined).then(res => {
            setActivityDates(res.data?.records);
            setIsLoadingDates(false);
        })


    }


    const checkVisitorsLimit = (visitor) => {

        const visitorsSUM = visitor.type === 'kid' ? (store.visitors.adults || 0) + visitor.val
            : (visitor.val || 0) + (store.visitors.underAge || 0)

        return visitorsSUM <= store.lpParams.maxParticiaptes

    }

    const validateTicketsNumber = (ticketsAvailable, ticketsSelected, activityDate) => {

        const selectedDate = activityDate ? activityDate : store.activityDate;


        if (ticketsAvailable < ticketsSelected) {
            // disable step
            myStepsActivity[store.currentStep].disabled = true;
            myStepsMOBILE[store.currentStep].disabled = true;

            dispatch(setErrorMessageStep('אין מספיק כרטיסים בתאריך הזה'));
            return false

        }
        else if (selectedDate) {
            // enable step

            myStepsActivity[store.currentStep].disabled = false;
            myStepsMOBILE[store.currentStep].disabled = false;
            if (store.errorMessageStep) dispatch(setErrorMessageStep(undefined));

            return true
        }
        else {
            return true
        }
    }


    const updateKidAmount = (newValue) => {
        const visitorsSUM = (store.visitors.adults || 0) + newValue
        if (belowMinLimit(newValue)){
            return;
        }
        
        const checkVisitorsLimitResult = checkVisitorsLimit({ val: newValue, type: 'kid' })
        const validateAvailableTickets = validateTicketsNumber(ticketsAvailable, visitorsSUM);

        getDates(visitorsSUM)
        if (!checkVisitorsLimitResult) setErrorMessageHead(VISITORS_LIMIT_ERROR_MSG + store.lpParams.maxParticiaptes);
        if (!validateAvailableTickets) setErrorMessageHead(NO_AVAILABLE_TICKETS_TODAY);


        if (errorMessageHead && checkVisitorsLimitResult) setErrorMessageHead(false);

        if (+newValue >= 0 && checkVisitorsLimitResult && validateAvailableTickets) {
            dispatch(setVisitors({ underAge: newValue }));
        }

    }

    const updateAdultAmount = (newValue) => {
        const visitorsSUM = (newValue || 0) + (store.visitors.underAge || 0);
        if (belowMinLimit(newValue) || visitorsSUM === 0){
            return;
        }
        
        const checkVisitorsLimitResult = checkVisitorsLimit({ val: newValue, type: 'adult' });
        const validateAvailableTickets = validateTicketsNumber(ticketsAvailable, visitorsSUM);

        getDates(visitorsSUM)
        if (!checkVisitorsLimitResult) setErrorMessageHead(VISITORS_LIMIT_ERROR_MSG + store.lpParams.maxParticiaptes);
        if (!validateAvailableTickets) setErrorMessageHead(NO_AVAILABLE_TICKETS_TODAY);

        if (errorMessageHead && checkVisitorsLimitResult) setErrorMessageHead(false); //cleanup

        if (newValue >= 0 && checkVisitorsLimitResult && validateAvailableTickets) {
            dispatch(setVisitors({ adults: newValue }));
        }
    }


    const getDates = (newNumber, type) => {

        getDatesSF(newNumber, store.selectedActivity?.productId, store.lpName || undefined).then(res => {
            setActivityDates(res.data?.records)
        });

    }

    const belowMinLimit = (newNumber, type) => {
        return store.isInternalMode ? newNumber < 0 : newNumber < 1;
    }

    const { Pricing, Id } = store.selectedActivity || {};
    const { visitors } = store || {};
    const genericEvent = isGenericEventProduct(store.selectedActivity);
    const lpGenericOnly = isGenericOnlyLp(store.products);



    return <div id="main-content" className="LandingPageStepOne">
        {errorMessageHead && <div className="alert alert-text"  aria-live="polite"
        key={errorMessageHead} role="alert" >{errorMessageHead}</div>}
        <div className="ps-lg-5 pe-lg-4 p-3 pt-lg-4 pb-lg-0">
            <div className="visitors-container">
                <div><h2 className="almoni_tzar_normal text-start">בחרו כמות משתתפים</h2></div>
                {!(genericEvent || lpGenericOnly) && <MahutiInputVisitors visitor='ילד' setVisitorsNumber={updateKidAmount} visitorsNumber={store.visitors?.underAge } price={Pricing?.kids} productId={Id} setActivityDates={setActivityDates} disabled={errorMessageHead} isInternal ={store.isInternalMode}/>}
                <MahutiInputVisitors visitor='מבוגר' setVisitorsNumber={updateAdultAmount} visitorsNumber={store.visitors?.adults } price={Pricing?.adults} productId={Id} setActivityDates={setActivityDates} disabled={errorMessageHead} isInternal ={store.isInternalMode} />
            </div>

            {false && <div>
                <div className="alert bg-body border-0 d-flex justify-content-start alert-counter alef" role="alert"> לתאריך המבוקש אין מספיק מקומות, אנא בחרו תאריך אחר</div>
            </div>}
            <div className={"mt-lg-5 mt-3 calendar_container" + (isLoadingDates ? ' isLoading' : '')}>
                {isLoadingDates && <div className="loader-container"> <div className="col-loader"><div className="loader" /></div></div>}
                <div className="calender-section">
                        <h2 className="almoni_tzar_normal d-flex justify-content-start mb-3">בחרו תאריך</h2>
                        {activityDates?.length > 0 && <MahutiCalender
                            setErrorMessageHead={setErrorMessageHead}
                            activityDates={activityDates}
                            setTicketsAvailable={setTicketsAvailable}
                            visitors={visitors}
                            productId={Id}
                            validateTicketsNumber={validateTicketsNumber} />}
                </div>


            </div>
        </div>
    </div>
}